import {css} from 'lit';
export const styles = css`#copy-button {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 40px;
  width: 40px;
  padding: 10px;
  transition: color 1s cubic-bezier(0, 1.15, 0, 1);
  border-top-left-radius: 6px;
}

button:focus,
button:hover {
  color: var(--code-button-focus-color, hsla(0 100% 100% / 0.75));
}

button:active {
  color: var(--code-button-active-color, #4caf50);
}

::slotted(pre) {
  margin-bottom: 0 !important;
}

[aria-hidden="true"] {
  display: none !important;
}
`;
export default styles;
